<template>
    <div>
        <hos_apply_title title="预约信息"></hos_apply_title>
        <el-form :model="detail" class="mt10" label-position="left" size="mini">
            <el-form-item label="预约医院:" label-width="80px" class="marginBottom">
                {{detail.hopeHosName}}
            </el-form-item>
            <el-form-item :label="$route.params.type == 'check' ? '预约检查日期:':'预约手术日期:'" label-width="100px" class="marginBottom">
                {{detail.hopeTime | formateTime}}
            </el-form-item>
            <!-- 页面判断 -->
            <template v-if="$route.params.type == 'check'">
                <el-form-item label-width="80px" :label="index == 0 ? '检查项目:' : ''" v-for="(num,index) in detail.inspectList" :key="index" class="marginBottom">
                    {{index+ 1 + '. '}}{{num.inspectName}}
                </el-form-item>
            </template>
            <template v-else>
                <el-form-item label-width="80px" :label="index == 0 ? '手术名称:' : ''" v-for="(num,index) in detail.operationList" :key="index" class="marginBottom">
                    {{index+ 1 + '. '}}{{num.operationName}}
                </el-form-item>
            </template>
            <template v-if="state == 'FINSH'">
                <el-form-item :label="$route.params.type == 'check' ? '安排检查日期:':'安排手术日期:'" label-width="100px" style="color:#FF0000 !important;" class="marginBottom">
                    {{detail.acceptTime | formateTime}}
                </el-form-item>
                <el-form-item class="marginBottom">
                   <hos_tip content="此安排时间仅供参考，以实际预约时间为准"></hos_tip>
                </el-form-item>
                <el-form-item label="医生备注:" label-width="80px" style="color:#FF0000 !important;" class="marginBottom">
                   {{detail.remark}}
                </el-form-item>
            </template>
            <slot name="cancle">

            </slot>
            <el-form-item class="flex jcc mt60">
                <slot name="buttonGroup">

                </slot>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import hos_apply_title from './hos-apply-title'
    import hos_tip from './hos-tip'
    export default {
        name: "hos-appointment-info-detail",
        props:{
          state:{
              type:String
          },
            detail:{
                type:Object
            }
        },
        components:{
            hos_apply_title,hos_tip
        },
        filters:{
            formateTime(time){
                const handlerZero = (value) => {
                    return value < 10 ? '0' + value : value;
                };
                const dateObj = new Date(time);
                const Y = dateObj.getFullYear();
                const m = handlerZero(dateObj.getMonth() + 1);
                const d = handlerZero(dateObj.getDate());
                const W = dateObj.getDay();
                const H = handlerZero(dateObj.getHours());
                const M = handlerZero(dateObj.getMinutes());
                const S = handlerZero(dateObj.getSeconds());
                return Y+'-'+m+'-'+d+' '+H+':'+M
            }
        },
        data(){
            return {

            }
        },
        methods:{
            // addItem(){
            //     this.appInfoForm.selectNum.push('');
            // },
            // removeItem(index){
            //     this.appInfoForm.selectNum.splice(index,1);
            // }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/hos";
</style>